var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from '../../styled';
const Container = styled.div `
  position: relative;
  cursor: pointer;
  user-select: none;
  display: inline-block;
`;
const Background = styled.div `
  position: relative;
  height: 1.375rem;
  width: 2.375rem;
  border-radius: 14px;
  border: solid 0.0625rem ${({ theme }) => theme.toggle.borderColor};
  background-color: ${({ theme }) => theme.toggle.backgroundColor};
  transition: border 0.25s ease 0s, background-color 0.25s ease 0s;

  ${({ theme, isToggledOn }) => isToggledOn &&
    css `
      border: solid 0.0625rem ${theme.colors.GREEN_600};
      background-color: ${theme.colors.GREEN_600};
    `};

  ${({ theme, disabled, isToggledOn }) => disabled &&
    css `
      cursor: not-allowed;
      border-color: ${isToggledOn
        ? theme.colors.GREEN_200
        : theme.toggle.backgroundColor};
      background-color: ${isToggledOn
        ? theme.colors.GREEN_200
        : theme.toggle.backgroundColor};
    `};
`;
const Circle = styled.div `
  position: absolute;
  top: 0.0625rem;
  left: 0.0625rem;
  height: 1.375rem;
  width: 1.375rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  transition: background-color, transform 0.25s ease 0s;
  box-shadow: 0 0.125rem 0.25rem 0 ${({ theme }) => theme.colors.SHADOW_DEFAULT},
    0 0 0.125rem 0 ${({ theme }) => theme.colors.SHADOW_DARK};

  ${({ isToggledOn }) => isToggledOn &&
    css `
      transform: translateX(1rem);
    `};

  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
      box-shadow: 0 0.125rem 0.25rem 0
        ${({ theme }) => theme.colors.SHADOW_DEFAULT};
    `};
`;
const noop = () => { };
const Toggle = (_a) => {
    var { isToggledOn, disabled, onClick } = _a, restProps = __rest(_a, ["isToggledOn", "disabled", "onClick"]);
    return (React.createElement(Container, Object.assign({}, restProps, { onClick: disabled ? noop : onClick }),
        React.createElement(Background, { isToggledOn: isToggledOn, disabled: disabled }),
        React.createElement(Circle, { isToggledOn: isToggledOn, disabled: disabled })));
};
export default Toggle;
//# sourceMappingURL=index.js.map